module.exports = __webpack_public_path__ + "static/media/void.e478537f.PNG";